<script setup>
</script>

<template>
    <div class="access-pending">
        <p class="access-pending__title">Access Request Pending</p>
        <p class="access-pending__text">
            Your access request has already been submitted and is currently under review by the Hub team.
        </p>
        <p class="access-pending__text">
            We will notify you by email once your request has been approved.
        </p>
        <p class="access-pending__text">
            If you believe this is an error, please contact the Hub administrator.
        </p>
    </div>
</template>

<style scoped>
.access-pending {
    background: #EDE7F6;
    border-radius: 8px;
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.access-pending__title {
    color: #2E1A47;
    font-size: 15px;
    font-weight: 700;
    margin: 0;
    text-align: left;
}
.access-pending__text {
    color: #4B444D;
    font-size: 14px;
    line-height: 1.6;
    margin: 0;
    text-align: left;
}
</style>
